import { FilterOption } from '../_WMS/FilterComponent'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'ProcessId',
    label: 'ID Proceso',
    type: 'numeric'
  },
  {
    order: 2,
    key: 'InitialDate',
    label: 'Fecha Desde',
    type: 'date'
  },
  {
    order: 3,
    key: 'FinalDate',
    label: 'Fecha Hasta',
    type: 'date'
  },
  {
    order: 4,
    key: 'StatusProcessId',
    label: 'Estado',
    type: 'precreated'
  },
  {
    order: 5,
    key: 'typeProcessId',
    label: 'Tipo Proceso',
    type: 'precreated'
  }
]

export const defaultFiltersProcess = [
  {
    key: 'StatusId',
    value: 1,
    label: 'Estado',
    displayValue: 'Creado'
  },
  {
    key: 'StatusId',
    value: 2,
    label: 'Estado',
    displayValue: 'Iniciado'
  },
  {
    key: 'StatusId',
    value: 3,
    label: 'Estado',
    displayValue: 'Finalizado'
  },
  {
    key: 'StatusId',
    value: 4,
    label: 'Estado',
    displayValue: 'Con Errores'
  }
]
